import { render, staticRenderFns } from "./gameRechg.vue?vue&type=template&id=e2d00ae6&scoped=true&"
import script from "./gameRechg.vue?vue&type=script&lang=js&"
export * from "./gameRechg.vue?vue&type=script&lang=js&"
import style0 from "./gameRechg.vue?vue&type=style&index=0&id=e2d00ae6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d00ae6",
  null
  
)

export default component.exports